import './App.css';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import Main from './pages/Main';
// @ts-ignore
import { useRoot, useBranch } from 'baobab-react/hooks';
import tree from './data/baobab';
import CircularProgress from '@material-ui/core/CircularProgress';


function Wrapper({ children }: any) {
    const { token } = useBranch({
        token: ['keycloak', 'token']
    });
    
    if (token) {
        return children;
    } else {
        return (
            <div
                style={{
                    width: '100%',
                    height: '100%',
                    position: 'fixed',
                    backgroundColor: '#fff',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                }}
            >
                <CircularProgress />
            </div>
        );
    }
}

console.log('govno');

function App() {
    const Root = useRoot(tree);

    return (
        <Root>
            <Wrapper>
            <Router>
                <Switch>
                    <Route path="/">
                        <Main />
                    </Route>
                </Switch>
            </Router>
            </Wrapper>
        </Root>
    );
}

export default App;
